<template>
  <div>
    <section role="side-modal">
      <side-modal :sides="navs" @cancela="cancela()">
        <template :slot="navs[0].identidade">
          <div class="side-body">
            <div class="row">
              <form>
                <!-- Estados e Municípios -->
                <div class="row row-field">
                  <div class="col-md-6 col-sm-6">
                    <field-validation
                      label="Estado"
                      field="estadoModal"
                      :status="errors"
                      :custom-errors="apiErrors"
                      :show-icon="false"
                    >
                      <select
                        class="form-control"
                        name="estadoModal"
                        v-model="enderecoEditado.estado"
                        v-validate
                        data-vv-as="Estado"
                      >
                        <option value selected>Escolha</option>
                        <option
                          v-for="estado in estados"
                          :value="estado.sigla"
                          :key="estado.id"
                          @change="obtemMunicipios(enderecoEditado.estado, 'modal')"
                        >
                          {{ estado.nome | tudoMaiusculo }}
                        </option>
                      </select>
                    </field-validation>
                  </div>
                  <div class="col-md-6 col-sm-6">
                    <field-validation
                      label="Município"
                      field="municipioModal"
                      :status="errors"
                      :custom-errors="apiErrors"
                      :show-icon="false"
                    >
                      <select
                        class="form-control"
                        name="municipioModal"
                        v-model="enderecoEditado.municipio"
                        v-validate
                        data-vv-as="Município"
                        @change="limpaModal()"
                      >
                        <option value selected>Escolha</option>
                        <option
                          v-for="municipio in municipios"
                          :value="municipio.id"
                          :key="municipio.id"
                        >
                          {{ municipio.nome }}
                        </option>
                      </select>
                    </field-validation>
                  </div>
                </div>

                <!-- Campo Logradouro Modal -->
                <div class="row row-field" v-if="mostraLista">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Logradouro</label>
                      <select
                        class="form-control"
                        v-model="enderecoLista"
                        :size="enderecos.length > 10 ? 10 : enderecos.length + 1"
                        @change="valoraLista()"
                      >
                        <option value selected>
                          Selecione o seu logradouro ou refine sua busca
                        </option>
                        <option
                          v-for="endereco in enderecos"
                          :value="endereco"
                          :key="enderecos.indexOf(endereco)"
                          @dblclick="inclui()"
                        >
                          {{ `${endereco.logradouro.tipo} ${endereco.logradouro.nome} - ${endereco.bairro.nome} - ${cepMasked(endereco.cep)}` | tudoMaiusculo }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-12 col-sm-12" style="padding-top: 0px">
                    <botao
                      estilo="vazado-verde-dir"
                      rotulo="Ok"
                      icone="fa-check fa-lg"
                      style="font-size: 12px"
                      @clicado="inclui()"
                    />
                    <botao
                      estilo="vazado-cinza-dir"
                      rotulo="Limpar"
                      icone="fa-eraser fa-lg"
                      style="font-size: 12px"
                      @clicado="montaModal()"
                    />
                  </div>
                </div>

                <!-- Campo Número, Complemento, Bairro e CEP Modal -->
                <transition name="fade" mode="out-in">
                  <div class="row row-field" v-show="logradouroInvalido">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="tipoLogradouro">Tipo</label>
                        <select
                          class="form-control"
                          name="tipoLogradouro"
                          v-model="enderecoEditado.tipoLogradouro"
                          v-validate="'required'"
                        >
                          <option value selected>Escolha</option>
                          <option
                            v-for="tipoLogradouro in tiposLogradouros"
                            :value="tipoLogradouro.descricao"
                            :key="tipoLogradouro.id"
                          >
                            {{ tipoLogradouro.descricao }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-9">
                      <div class="form-group">
                        <label for="logradouroModal">Logradouro</label>
                        <input
                          type="text"
                          name="logradouroModal"
                          id="logradouroModal"
                          class="form-control"
                          v-model="enderecoEditado.logradouro"
                        />
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <field-validation
                          label="CEP"
                          field="cepModal"
                          :status="errors"
                          :custom-errors="apiErrors"
                          :show-icon="false"
                        >
                          <input
                            type="text"
                            name="cepModal"
                            id="cepModal"
                            class="form-control"
                            v-validate
                            data-vv-as="CEP"
                            v-mask="'##.###-###'"
                            v-model="enderecoEditado.cep"
                          />
                        </field-validation>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <field-validation
                          label="Bairro"
                          field="bairroModal"
                          :status="errors"
                          :custom-errors="apiErrors"
                          :show-icon="false"
                        >
                          <input
                            type="text"
                            name="bairroModal"
                            id="bairroModal"
                            class="form-control"
                            v-validate
                            data-vv-as="Bairro"
                            v-model="enderecoEditado.bairro"
                          />
                        </field-validation>
                      </div>
                    </div>
                    <div class="col-sm-4 col-xs-5">
                      <div class="form-group">
                        <field-validation
                          label="Número"
                          field="numeroModal"
                          :status="errors"
                          :custom-errors="apiErrors"
                          :show-icon="false"
                        >
                          <input
                            type="text"
                            name="numeroModal"
                            id="numeroModal"
                            class="form-control"
                            v-validate
                            data-vv-as="Número"
                            v-mask="'######'"
                            v-model="enderecoEditado.numero"
                          />
                        </field-validation>
                      </div>
                    </div>
                    <div class="col-sm-2 col-xs-2">
                      <div class="checkbox-default">
                        <label for="semNumeroModal">S/N</label>
                        <br />
                        <input
                          type="checkbox"
                          name="semNumeroModal"
                          id="semNumeroModal"
                          tabindex="-1"
                          v-model="semNumero"
                          @change="zeraNumero('#numeroModal')"
                        />
                      </div>
                    </div>
                    
                    <div class="col-sm-6 col-xs-5">
                      <div class="form-group">
                        <label for="complementoModal">Complemento</label>
                        <input
                          type="text"
                          name="complementoModal"
                          class="form-control"
                          value
                          id="complementoModal"
                          v-model="enderecoEditado.complemento"
                        />
                      </div>
                    </div>
                  </div>
                </transition>
              </form>
            </div>
          </div>
          <div class="side-footer">
            <botao
              tipo="button"
              estilo="cheio-cinza"
              rotulo="Cancelar"
              icone="cancela-modal"
              @clicado="cancela()"
            />
            <botao
              tipo="button"
              estilo="cheio-verde"
              :rotulo="logradouroInvalido ? 'Incluir' : 'Selecionar'"
              icone="ok-modal"
              @clicado="inclui()"
            />
          </div>
        </template>
      </side-modal>
    </section>
    <section role="form">
      <div>
        <!-- Campo CEP, Logradouro e Número do formulário -->
        <div class="row row-field">
          <div class="col-sm-3">
            <div class="form-group">
              <label for="cep">CEP&nbsp;&nbsp;</label>
              <div class="input-group">
                <input
                  type="text"
                  name="cep"
                  class="form-control"
                  value
                  id="cep"
                  :class="errorInputCep"
                  v-validate="'required'"
                  v-model="enderecoEditado.cep"
                  v-mask="'##.###-###'"
                  :disabled="disabled"
                  @keydown.enter="enderecoEditado.cep ? busca(enderecoEditado.cep) : buscaAbreModal(false)"
                />
                <span class="input-group-btn">
                  <botao
                    estilo="vazado-verde-dir"
                    rotulo
                    icone="fa-search fa-lg"
                    style="height: 34px; font-size: 12px; margin-bottom: 0"
                    @clicado="busca(enderecoEditado.cep)"
                    v-tooltip.right="'Busca endereço'"
                    :disabled="disabled"
                  />
                </span>
              </div>
              <span v-show="errors.has('cep')" class="error">{{ errors.first('cep') }}</span>
            </div>
          </div>
        </div>
        <div class="row row-field">
          <!-- Tipo logradouro -->
          <field-validation
            css-class="col-sm-3"
            label="Tipo"
            field="tipoLogradouro"
            :status="errors"
            :custom-errors="apiErrors"
            :show-icon="false"
            v-sem-acentos
          >
            <select
              class="form-control"
              name="tipoLogradouro"
              v-model="enderecoEditado.tipoLogradouro"
              v-validate="'required'"
              data-vv-as="Tipo"
              :disabled="disabled"
            >
              <option value :selected="true">Escolha</option>
              <option
                v-for="tipoLogradouro of tiposLogradouros"
                :value="tipoLogradouro.descricao"
                :key="tipoLogradouro.id"
              >
                {{ tipoLogradouro.descricao }}
              </option>
            </select>
          </field-validation>
          <!-- Logradouro -->
          <field-validation
            css-class="col-sm-6"
            label="Logradouro"
            field="logradouro"
            :status="errors"
            :custom-errors="apiErrors"
            :show-icon="false"
          >
            <input
              type="text"
              name="logradouro"
              id="logradouro"
              class="form-control"
              v-model="enderecoEditado.logradouro"
              v-sem-acentos
              v-validate="'required|max:40'"
              data-vv-as="Logradouro"
              :disabled="disabled"
            />
          </field-validation>
          <!-- Número e checkbox S/N -->
        </div>
        <!-- Campos Número, S/N e Complemento em telas extra small -->
        <div class="row row-field visible-xs-12 hidden-sm hidden-md hidden-lg">
          <field-validation
            css-class="col-xs-5"
            label="Número"
            field="numero-xs"
            :status="errors"
            :custom-errors="apiErrors"
            :show-icon="false"
          >
            <input
              type="text"
              name="numero-xs"
              id="numero-xs"
              class="form-control"
              v-mask="'#######'"
              v-model="enderecoEditado.numero"
              v-validate="'required'"
              data-vv-as="Número"
              :disabled="disabled"
            />
          </field-validation>
          <div class="col-xs-2">
            <div class="checkbox-default">
              <label for="semNumero-xs">S/N</label>
              <br />
              <input
                type="checkbox"
                name="semNumero-xs"
                id="semNumero-xs"
                tabindex="-1"
                v-model="semNumero"
                @change="zeraNumero('#numero-xs')"
                :disabled="disabled"
              />
            </div>
          </div>
          <div class="col-xs-5">
            <div class="form-group">
              <label for="complemento-xs">Complem.</label>
              <input
                type="text"
                name="complemento-xs"
                class="form-control"
                value
                id="complemento-xs"
                v-model="enderecoEditado.complemento"
                :disabled="disabled"
              />
            </div>
          </div>
        </div>
        <!-- Campos Complemento, Estado, Município e Bairro do formulário -->
        <div class="row row-field">
          <field-validation
            css-class="col-sm-3 hidden-xs"
            label="Complemento"
            field="complemento"
            :status="errors"
            :custom-errors="apiErrors"
            :show-icon="false"
          >
            <input
              type="text"
              name="complemento"
              id="complemento"
              class="form-control"
              v-model="enderecoEditado.complemento"
              v-sem-acentos
              v-validate="'max:15'"
              data-vv-as="Complemento"
              :disabled="disabled"
            />
          </field-validation>
          
          <field-validation
            css-class="col-sm-3"
            label="Bairro"
            field="bairro"
            :status="errors"
            :custom-errors="apiErrors"
            :show-icon="false"
          >
            <input
              type="text"
              name="bairro"
              id="bairro"
              class="form-control"
              v-model="enderecoEditado.bairro"
              v-sem-acentos
              v-validate="'required|max:20'"
              data-vv-as="Bairro"
              :disabled="disabled"
            />
          </field-validation>

          <field-validation
            css-class="col-sm-2 hidden-xs"
            label="Número"
            field="numero"
            :status="errors"
            :custom-errors="apiErrors"
            :show-icon="false"
          >
            <input
              type="text"
              name="numero"
              id="numero"
              class="form-control"
              v-mask="'#######'"
              v-model="enderecoEditado.numero"
              v-validate="'required'"
              data-vv-as="Número"
              :disabled="disabled"
            />
          </field-validation>

          <div class="col-sm-1 hidden-xs">
            <div class="checkbox-default">
              <label for="semNumero">S/N</label>
              <br />
              <input
                type="checkbox"
                name="semNumero"
                id="semNumero"
                tabindex="-1"
                v-model="semNumero"
                @change="zeraNumero('#numero')"
                :disabled="disabled"
              />
            </div>
          </div>
        </div>

        <!-- Campos Estado e Município do formulário -->
        <div class="row row-field">
            <field-validation
            css-class="col-md-4 col-sm-4"
            label="Estado"
            field="estado"
            :status="errors"
            :custom-errors="apiErrors"
            :show-icon="false"
          >
            <select
              class="form-control"
              name="estado"
              v-model="enderecoEditado.estado"
              v-validate="'required'"
              data-vv-as="Estado"
              @change="obtemMunicipios(enderecoEditado.estado, 'formulario')"
              :disabled="disabled"
            >
              <option value :selected="true">Escolha</option>
              <option
                v-for="estado in estados"
                :value="estado.sigla"
                :key="estado.id"
              >
                {{ estado.nome | tudoMaiusculo }}
              </option>
            </select>
          </field-validation>



          <field-validation
            css-class="col-md-4 col-sm-4"
            label="Município"
            field="municipio"
            :status="errors"
            :custom-errors="apiErrors"
            :show-icon="false"
          >
            <select
              class="form-control"
              name="municipio"
              v-model="enderecoEditado.municipio"
              v-validate="'required'"
              data-vv-as="Município"
              :disabled="disabled || !dadosCarregados"
            >
              <option value="">Escolha</option>
              <option
                v-for="municipio in municipios"
                :value="municipio.nome"
                :key="municipio.id"
              >
                {{ municipio.nome }}
              </option>
            </select>
          </field-validation>
        </div> 

      </div>
    </section>
  </div>
</template>
<script>
import axios from 'axios';
import Botao from '@/components/botao';
import SideModal from '@/components/side-modal';
import StringHelper from '@/helpers/StringHelper';
import ArrayHelper from '@/helpers/ArrayHelper';
import { setTimeout } from 'timers';
import EnderecoService from '@/services/enderecoService';
import { getEstados } from '@/services/estadoService';

export default {
  name: 'Endereco',

  data() {
    return {
      enderecoEditado: {
        cep: '',
        tipoLogradouro: '',
        logradouro: '',
        bairro: '',
        municipio: '',
        estado: '',
        numero: '',
        complemento: '',
        georreferenciado: false,
        inseridoPeloUsuario: false,
      },
      estados: [],
      municipios: [],
      enderecos: [],
      tiposLogradouros: [],
      navs: [
        {
          titulo: 'Recadastramento',
          subtitulo: 'Endereço',
          subtDetalhe: 'Recadastrar Endereço',
          largura: 750,
          identidade: 'endereco',
          abreProximo: false,
          aberto: false,
        },
      ],
      enderecoLista: {
        logradouro: {
          nome: '',
        },
        bairro: {
          nome: '',
        },
        cep: '',
        numero: '',
        complemento: '',
      },
      semNumero: false,
      mostraLista: false,
      naoValidaNumero: false,
      logradouroInvalido: false,
      apiErrors: null,
    };
  },

  props: {
    api: '',
    apiUrl: '',
    parentCep: '',
    parentTipoLogradouro: '',
    parentLogradouro: '',
    parentBairro: '',
    parentMunicipio: '',
    parentEstado: '',
    parentNumero: '',
    parentComplemento: '',
    parentGeorreferenciado: false,
    parentInseridoPeloUsuario: false,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    errorInputCep() {
      if (this.errors.has('cep')) return 'form-control-login-error';
    },
    dadosCarregados() {
      return this.estados.length > 0 && this.municipios.length > 0;
    }
  },

  methods: {
    /*
     * Manipula modal
     */
    abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },

    /*
     * Requisições
     */

    async busca(cep) {
      if (!cep && this.enderecoEditado.cep) {
        cep = this.enderecoEditado.cep;
      }

      if (!cep) {
        this.$root.$refs.toastr.e('Digite um CEP para buscar', 'Atenção');
        return;
      }

      const cepLimpo = this.cepPlain(cep);
      if (cepLimpo.length !== 8) {
        this.$root.$refs.toastr.e('CEP inválido', 'Atenção');
        return;
      }

      // Mostra o carregamento manualmente sem usar o interceptor
      if (this.$root.$refs.loading) {
        this.$root.$refs.loading.show();
      }

      try {
        const apis = [
          {
            name: 'ViaCEP',
            url: `https://viacep.com.br/ws/${cepLimpo}/json/`,
            transform: (data) => ({
              cep: data.cep,
              uf: data.uf,
              localidade: data.localidade,
              bairro: data.bairro,
              logradouro: data.logradouro
            })
          },
          {
            name: 'BrasilAPI',
            url: `https://brasilapi.com.br/api/cep/v1/${cepLimpo}`,
            transform: (data) => ({
              cep: data.cep,
              uf: data.state,
              localidade: data.city,
              bairro: data.neighborhood,
              logradouro: data.street
            })
          },
          {
            name: 'ApiCEP',
            url: `https://cdn.apicep.com/file/apicep/${cepLimpo.slice(0, 5)}-${cepLimpo.slice(5)}.json`,
            transform: (data) => ({
              cep: data.code,
              uf: data.state,
              localidade: data.city,
              bairro: data.district,
              logradouro: data.address
            })
          }
        ];

        let endereco = null;
        let apiUsada = '';
        let erros = [];

        // Cria uma instância separada do axios que não usará o interceptor global
        const axiosInstance = axios.create();
        
        // Define timeout mais curto para evitar esperas longas
        const axiosConfig = {
          timeout: 5000,
          headers: {
            'X-Request-Type': 'cep-service'
          }
        };

        for (const api of apis) {
          try {
            const response = await axiosInstance.get(api.url, axiosConfig);
            
            if (response.data && !response.data.erro) {
              endereco = api.transform(response.data);
              apiUsada = api.name;
              break;
            }
          } catch (error) {
            erros.push(`${api.name}: ${error.message}`);
            console.warn(`Falha ao buscar CEP via ${api.name}:`, error);
            continue;
          }
        }

        if (!endereco) {
          console.error('Falhas nas APIs:', erros);
          throw new Error('cep-service-unavailable');
        }

        this.enderecoEditado.cep = this.cepMasked(cepLimpo);

        // Use a mesma instância do axios para todas as requisições subsequentes
        const estadoResponse = await axiosInstance.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados', axiosConfig);
        const estados = estadoResponse.data;
        
        const estado = estados.find(e => e.sigla === endereco.uf);
        if (!estado) {
          throw new Error('Estado não encontrado');
        }

        if (this.estados.length === 0) {
          this.estados = estados.map(e => ({
            id: e.id,
            nome: e.nome,
            sigla: e.sigla
          }));
        }

        const municipiosResponse = await axiosInstance.get(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estado.id}/municipios`,
          axiosConfig
        );
        
        this.municipios = municipiosResponse.data.map(m => ({
          id: m.id,
          nome: this.removerAcentos(m.nome)
        }));

        await this.$nextTick();

        const novoEndereco = {
          cep: this.cepMasked(cepLimpo),
          estado: endereco.uf,
          municipio: this.removerAcentos(endereco.localidade),
          bairro: this.removerAcentos(endereco.bairro),
          logradouro: this.removerAcentos(endereco.logradouro),
          tipoLogradouro: this.extrairTipoLogradouro(endereco.logradouro),
          complemento: this.enderecoEditado.complemento || '',
          numero: this.enderecoEditado.numero || '',
          georreferenciado: false,
          inseridoPeloUsuario: false
        };

        Object.assign(this.enderecoEditado, novoEndereco);
        
        console.log(`CEP encontrado via ${apiUsada}`);

        await this.$nextTick();
        this.$validator.reset();

      } catch (error) {
        console.error('Erro na busca de CEP:', error);
        if (error.message === 'cep-service-unavailable') {
          this.emiteAlertaInfo(
            'Sistema de CEP indisponível',
            'Por favor, tente novamente em alguns instantes ou preencha os campos manualmente'
          );
        }
        this.enderecoEditado.cep = '';
      } finally {
        // Esconde o carregamento manualmente
        if (this.$root.$refs.loading) {
          this.$root.$refs.loading.hide();
        }
      }
    },
    buscaAbreModal(listar) {
      return axios
        .get(`${this.api}estados/${this.enderecoEditado.estado}/municipios`)
        .then(municipios => (this.municipios = municipios.data.data))
        .then(() => {
          ArrayHelper.geraTamanhoLimitado(this.municipios, 'nome', 20);
          this.mostraLista = listar;
          this.abreModal('endereco');
          this.errors.clear();
        })
        .catch(error => this.emiteAlerta(error.response.data.message));
    },
    removerAcentos(str) {
      return str.normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Remove acentos
        .replace(/[^a-zA-Z0-9\s]/g, '') // Remove caracteres especiais
        .toUpperCase()
        .trim();
    },
    obtemMunicipios(sigla, elemento) {
      if (!sigla) return;
      
      this.obtemMunicipiosPor(sigla)
        .then(() => {
          if (elemento === 'modal') {
            this.enderecoEditado.municipio = '';
            this.limpaModal();
          }
          if (elemento === 'formulario') {
            const municipioAtual = this.enderecoEditado.municipio;
            this.enderecoEditado.municipio = '';
            
            if (municipioAtual && this.municipios.some(m => m.nome === municipioAtual)) {
              this.$nextTick(() => {
                this.enderecoEditado.municipio = municipioAtual;
              });
            }
          }
        })
        .catch(error => {
          console.error('Erro ao obter municípios:', error);
          this.emiteAlerta('Erro ao carregar municípios');
        });
    },
    obtemTiposLogradouros() {
      return axios
        .get(`${this.apiUrl}recadastramento-servidores/tipos-logradouros`, {
          headers: {
            Authorization: this.$store.state.token,
          },
        })
        .then(response => response.data)
        .then(tipos => (this.tiposLogradouros = tipos))
        .catch(error => this.emiteAlerta(error.response.data.message));
    },
    buscaModal(nome, municipio, estado) {
      // Previne clique em 'Buscar' com logradouro vazio
      if (!nome) {
        this.$validator.validate(
          'logradouroModal',
          this.enderecoEditado.logradouro,
        );
        return;
      }
      // Previne clique em 'Buscar' com município vazio e força alerta de erro no input (valorando com null)
      if (!municipio) {
        this.enderecoEditado.municipio = null;
        return;
      }
      return axios
        .get(
          `${this.api}logradouros?nome=${nome}&municipio=${municipio}&estado=${estado}`,
        )
        .then(enderecos => {
          this.enderecos = enderecos.data.data;
          this.mostraLista = true;
          this.logradouroInvalido = false;
        })
        .catch(error => {
          if (error.response.data.message === 'Logradouro não encontrado') {
            this.logradouroInvalido = true;
            this.enderecoEditado.inseridoPeloUsuario = true;
            this.enderecoEditado.bairro = '';
            this.emiteAlertaInfo(
              'Logradouro não encontrado',
              'Preencha os campos ao lado e cadastre seu endereço',
            );
            this.$nextTick(() => this.$validator.reset());
          } else {
            this.emiteAlerta(error.response.data.nome[0]);
          }
        });
    },
    normalizaString(str) {
      if (!str) return '';
      return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Remove acentos
        .replace(/[^a-zA-Z0-9\s]/g, '') // Remove caracteres especiais
        .toUpperCase()
        .trim();
    },
    async obtemMunicipiosPor(sigla) {
    try {
      const response = await axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${sigla}/municipios`);
      
      // Normalizar os nomes dos municípios removendo acentos
      this.municipios = response.data.map(municipio => ({
        id: municipio.id,
        nome: this.removerAcentos(municipio.nome) // Remove acentos e converte para maiúsculas
      }));
      
      // Ordenar os municípios por nome
      this.municipios.sort((a, b) => a.nome.localeCompare(b.nome));
      
      return this.municipios;
    } catch (error) {
      console.error(`Erro ao carregar municípios para ${sigla}:`, error);
      this.municipios = [];
      throw error;
    }
  },
    sanitizarDados(dados = this.enderecoEditado) {
      const dadosLimpos = { ...dados };
      
      // Garantir que o município seja uma string simples
      if (dadosLimpos.municipio && typeof dadosLimpos.municipio === 'object') {
        dadosLimpos.municipio = dadosLimpos.municipio.nome;
      }
      
      // Garantir que o estado seja uma string simples
      if (dadosLimpos.estado && typeof dadosLimpos.estado === 'object') {
        dadosLimpos.estado = dadosLimpos.estado.sigla;
      }
      
      // Garantir que todos os campos de texto sejam strings e limpos
      Object.keys(dadosLimpos).forEach(key => {
        if (typeof dadosLimpos[key] === 'string') {
          dadosLimpos[key] = dadosLimpos[key]
            .replace(/[^\w\s\.\-\,]/g, '')
            .trim();
        }
      });
      
      return dadosLimpos;
    },
    async obtemEstados() {
      try {
        const estadosData = getEstados();
        this.estados = estadosData.map(estado => ({
          id: estado.id,
          nome: estado.nome,
          sigla: this.getSiglaFromNome(estado.nome)
        }));
      } catch (error) {
        console.error('Erro ao carregar estados:', error);
        this.emiteAlerta("Erro ao carregar estados");
      }
    },
    getSiglaFromNome(nome) {
      const siglas = {
        'Acre': 'AC',
        'Alagoas': 'AL',
        'Amapá': 'AP',
        'Amazonas': 'AM',
        'Bahia': 'BA',
        'Ceará': 'CE',
        'Distrito Federal': 'DF',
        'Espírito Santo': 'ES',
        'Goiás': 'GO',
        'Maranhão': 'MA',
        'Mato Grosso': 'MT',
        'Mato Grosso do Sul': 'MS',
        'Minas Gerais': 'MG',
        'Pará': 'PA',
        'Paraíba': 'PB',
        'Paraná': 'PR',
        'Pernambuco': 'PE',
        'Piauí': 'PI',
        'Rio de Janeiro': 'RJ',
        'Rio Grande do Norte': 'RN',
        'Rio Grande do Sul': 'RS',
        'Rondônia': 'RO',
        'Roraima': 'RR',
        'Santa Catarina': 'SC',
        'São Paulo': 'SP',
        'Sergipe': 'SE',
        'Tocantins': 'TO'
      };
      return siglas[nome] || '';
    },
    naoSeiMeuCep() {
      this.enderecoEditado.cep = '';
      this.busca(this.enderecoEditado.cep);
    },

    /*
     * Manipulação de dados
     */

    async carregaDadosIniciais() {
      try {
        await this.obtemEstados();
        
        // Primeiro definir o estado
        this.enderecoEditado.estado = this.parentEstado || '';
        
        // Se tiver estado, carrega os municípios
        if (this.enderecoEditado.estado) {
          await this.obtemMunicipiosPor(this.enderecoEditado.estado);
          
          await this.$nextTick();
          
          if (this.parentMunicipio) {
            const municipioParentNormalizado = this.normalizaString(this.parentMunicipio);
            
            const municipioEncontrado = this.municipios.find(m => 
              this.normalizaString(m.nome) === municipioParentNormalizado
            );
            
            if (municipioEncontrado) {
              this.enderecoEditado.municipio = municipioEncontrado.nome;
            } else {
              console.warn('Município não encontrado na lista:', this.parentMunicipio);
            }
          }
        }
        
        if (typeof this.obtemTiposLogradouros === 'function') {
          this.obtemTiposLogradouros();
        }
        
        if (typeof this.cepMasked === 'function' && this.parentCep) {
          this.enderecoEditado.cep = this.cepMasked(this.parentCep);
        } else if (this.parentCep) {
          this.enderecoEditado.cep = this.formatarCep(this.parentCep);
        }
        
        this.enderecoEditado.tipoLogradouro = this.parentTipoLogradouro || '';
        
        if (this.parentLogradouro) {
          this.enderecoEditado.logradouro = this.parentLogradouro.toUpperCase();
        }
        
        if (this.parentBairro) {
          this.enderecoEditado.bairro = this.parentBairro.toUpperCase();
        }
        
        this.enderecoEditado.numero = this.parentNumero || '';
        
        if (this.parentComplemento) {
          this.enderecoEditado.complemento = this.parentComplemento.toUpperCase();
        }
        
        this.enderecoEditado.georreferenciado = this.parentGeorreferenciado || false;
        this.enderecoEditado.inseridoPeloUsuario = this.parentInseridoPeloUsuario || false;
      } catch (error) {
        console.error('Erro ao carregar dados iniciais:', error);
      }
    },
    cepPlain(cep) {
      return cep.replace(/\D+/g, '');
    },
    cepMasked(cep) {
      if (cep) {
        if (typeof cep === 'string') {
          return (
            cep.slice(0, 2) + '.' + cep.slice(2, 5) + '-' + cep.slice(5, 8)
          );
        }
        if (cep.unico) {
          return (
            cep.unico.slice(0, 2) +
            '.' +
            cep.unico.slice(2, 5) +
            '-' +
            cep.unico.slice(5, 8)
          );
        }
        return (
          cep.lado.direito.slice(0, 2) +
          '.' +
          cep.lado.direito.slice(2, 5) +
          '-' +
          cep.lado.direito.slice(5, 8)
        );
      }
    },
    valoraEnderecoEditado(dados) {
      dados = StringHelper.toUpperCaseInJson(dados);
      this.enderecoEditado.tipoLogradouro = this.valoraTipoLogradouro(
        dados.logradouro.tipo,
      );
      this.enderecoEditado.logradouro = StringHelper.limpaCaracterEspecial(
        dados.logradouro.nome,
      );
      this.enderecoEditado.bairro = StringHelper.limpaCaracterEspecial(
        dados.bairro.nome,
      );
      this.enderecoEditado.municipio = typeof dados.municipio === 'object' ? 
        dados.municipio.nome.toUpperCase() : 
        (dados.municipio ? dados.municipio.toUpperCase() : '');
      this.enderecoEditado.estado = dados.estado.sigla;
      this.enderecoEditado.georreferenciado = dados.georreferenciado;
      this.enderecoEditado.numero = '';
      this.enderecoEditado.complemento = '';
    },
    escolheEntreCepsIguais(dados) {
      this.enderecoEditado.estado = dados[0].estado.sigla;
      if (dados[0].municipio)
      this.enderecoEditado.municipio = dados.municipio && dados.municipio.nome 
      ? this.removerAcentos(dados.municipio.nome)
      : (dados.municipio ? this.removerAcentos(dados.municipio) : '');
      this.buscaAbreModal(true).then(() => (this.enderecos = dados));
    },
    montaModal(listar) {
      if (!this.enderecoEditado.estado) this.enderecoEditado.estado = 'SP';
      if (!this.enderecoEditado.municipio)
        this.enderecoEditado.municipio = 'SANTOS';
      this.mostraLista = listar;
      this.logradouroInvalido = true;
    },
    valoraLista() {
      if (this.enderecoLista) {
        this.enderecoEditado.inseridoPeloUsuario = false;
        this.enderecoEditado.cep = this.cepMasked(this.enderecoLista.cep);
        this.enderecoLista = StringHelper.toUpperCaseInJson(this.enderecoLista);
        this.enderecoEditado.tipoLogradouro = this.valoraTipoLogradouro(
          this.enderecoLista.logradouro.tipo,
        );
        this.enderecoEditado.logradouro = StringHelper.limpaCaracterEspecial(
          this.enderecoLista.logradouro.nome,
        );
        this.enderecoEditado.bairro = StringHelper.limpaCaracterEspecial(
          this.enderecoLista.bairro.nome,
        );
        this.enderecoEditado.georreferenciado =
          this.enderecoLista.georreferenciado;
        this.enderecoEditado.numero = '';
        this.enderecoEditado.complemento = '';
      }
    },
    valoraTipoLogradouro(tipo) {
      if (this.tiposLogradouros.some(item => item.descricao === tipo)) {
        return tipo;
      }
      return '';
    },
    inclui() {
      // Previne o submit sem ter selecionado endereço na lista
      if (this.mostraLista && !this.enderecoLista.cep) {
        this.emiteAlertaInfo(
          'Nenhum endereço foi selecionado',
          'Selecione seu endereço ou refine sua busca',
        );
        return;
      }
      // Previne o submit sem ter buscado o logradouro
      if (
        this.enderecoEditado.logradouro &&
        !this.enderecoEditado.cep &&
        !this.enderecoEditado.inseridoPeloUsuario
      ) {
        this.emiteAlertaInfo(
          'Você não buscou o endereço',
          'Clique em Buscar e selecione seu endereço',
        );
        return;
      }
      this.logradouroInvalido = false;
      this.fechaModal('endereco');
      return;
    },
    cancela() {
      this.carregaDadosIniciais();
      this.mostraLista = false;
      this.logradouroInvalido = false;
      this.semNumero = false;
      this.fechaModal('endereco');
    },
    limpaModal() {
      this.enderecoEditado.logradouro = '';
      this.enderecoEditado.bairro = '';
      this.mostraLista = false;
      this.logradouroInvalido = false;
      this.$nextTick(() => this.$validator.reset());
    },
    zeraNumero(htmlId) {
      if (this.semNumero) {
        this.enderecoEditado.numero = '0';
        document.querySelector(htmlId).disabled = true;
      } else {
        this.enderecoEditado.numero = '';
        document.querySelector(htmlId).disabled = false;
        document.querySelector(htmlId).focus();
      }
    },
    async salvar() {
      try {
        const success = await this.$validator.validateAll();
        if (!success) {
          this.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
          return false;
        }

        // Garantir que município e estado existam
        if (!this.enderecoEditado.municipio || !this.enderecoEditado.estado) {
          this.$root.$refs.toastr.e('Selecione estado e município', 'Atenção');
          return false;
        }

        const dadosSanitizados = this.sanitizarDados(this.enderecoEditado);
        const editado = this.montaEditadoApi(dadosSanitizados);
        
        // Em vez de salvar na API, apenas emitir os eventos com os dados
        this.$emit('submitEndereco', editado);
        
        // Armazenar localmente no componente pai
        this.$emit('atualizaEnderecoLocal', editado);
        
        return true;
      } catch (error) {
        console.error('Erro ao validar dados:', error);
        return false;
      }
    },
    montaEditadoApi(base) {
      let final = { ...base };
      
      // Garantir que os valores existam
      if (!final.municipio || !final.estado) {
        console.error('Município ou estado faltando:', final);
        return final;
      }

      final.cep = this.cepPlain(base.cep);
      
      // Garantir que município e estado sejam strings e em maiúsculas
      final.cidade = String(final.municipio).trim().toUpperCase();
      final.uf = String(final.estado).trim().toUpperCase();
      return final;
    },

    /*
     * Emissor de Mensagens
     */

    emiteSucesso(msgSucesso) {
      this.$emit('dadosOk', msgSucesso);
    },
    emiteAlertaInfo(msgAlerta, msgInfo) {
      this.$emit('dadosInvalidosInfo', msgAlerta, msgInfo);
    },
    emiteAlerta(msgAlerta) {
      this.$emit('dadosInvalidos', msgAlerta);
    },

    extrairTipoLogradouro(logradouro) {
      if (!logradouro) return '';
      
      const tipos = [
        'RUA', 'AVENIDA', 'TRAVESSA', 'ALAMEDA', 'PRAÇA',
        'ESTRADA', 'RODOVIA', 'VILA', 'VIELA', 'BECO'
      ];
      
      const palavras = logradouro.toUpperCase().split(' ');
      const tipo = tipos.find(t => t === palavras[0]);
      
      return tipo || '';
    },
  },

  watch: {
    'enderecoEditado.estado': async function(novoEstado, antigoEstado) {
      if (novoEstado) {
        try {
          const municipioAtual = this.enderecoEditado.municipio;
          await this.obtemMunicipios(novoEstado, 'formulario');
          
          if (!antigoEstado && this.parentMunicipio) {
            const municipioParentNormalizado = this.normalizaString(this.parentMunicipio);
            const municipioEncontrado = this.municipios.find(m => 
              this.normalizaString(m.nome) === municipioParentNormalizado
            );
            
            if (municipioEncontrado) {
              this.enderecoEditado.municipio = municipioEncontrado.nome;
            }
          } else if (municipioAtual) {
            const municipioAtualNormalizado = this.normalizaString(municipioAtual);
            const municipioEncontrado = this.municipios.find(m => 
              this.normalizaString(m.nome) === municipioAtualNormalizado
            );
            
            if (municipioEncontrado) {
              this.enderecoEditado.municipio = municipioEncontrado.nome;
            }
          }
        } catch (error) {
          console.error('Erro ao atualizar municípios:', error);
        }
      } else {
        this.municipios = [];
        this.enderecoEditado.municipio = '';
      }
    },
    'enderecoEditado.municipio': function(novoValor) {
      if (novoValor) {
        // Armazenar no state local em vez do Vuex
        this.$set(this.enderecoEditado, 'municipio', novoValor);
      }
    },
    municipios: function(novosmunicipios) {
    }
  },

  components: {
    Botao,
    SideModal,
  },

  created() {
    console.log(this.situacaoRecad);
    this.carregaDadosIniciais();

    this.$parent.$on('salvaPessoaEndereco', this.salvar);
  },
}
</script>

<style scoped>
.form-control-login-error,
.form-control-login-error:focus {
  border: 1px solid firebrick;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(178, 34, 34, 0.6);
}

input:disabled,
select:disabled,
.disabled {
  background-color: #eeee !important;
  opacity: 1 !important;
  cursor: not-allowed !important;
}

.disabled input,
.disabled select {
  background-color: #eeee !important;
  opacity: 1 !important;
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?1d70cfd4